const constants = {
  apiUrl: "https://api.travvify.com/api/admin/v2",
  // apiUrl: "http://localhost:8800/api/admin/v2",
};

export default constants;
